type ComputerWindowIconProps = {
  fill?: string;
};

const ComputerWindowIcon: React.FC<
  ComputerWindowIconProps & React.SVGAttributes<SVGElement>
> = ({ fill, ...svgProps }) => (
  <svg
    viewBox="0.902 0.56 208.046 151.874"
    width={208.046}
    height={151.874}
    {...svgProps}
  >
    {!!fill && <path d="M4.603 4.546h201.885v144.297H4.603z" fill={fill} />}
    <path
      d="M201.855.56H7.996C4.085.56.902 3.585.902 7.303v138.388c0 3.718 3.183 6.743 7.094 6.743h193.859c3.911 0 7.093-3.025 7.093-6.743V7.303c0-3.718-3.182-6.743-7.093-6.743Zm1.483 145.131c0 .777-.665 1.41-1.483 1.41H7.996c-.818 0-1.484-.633-1.484-1.41V29.185h196.826v116.506Zm0-121.839H6.512V7.303c0-.777.666-1.41 1.484-1.41h193.859c.818 0 1.483.633 1.483 1.41v16.549Z"
      fill="currentColor"
    />
    <path
      d="M18.65 18.9c2.49 0 4.509-1.92 4.509-4.286 0-2.367-2.018-4.285-4.508-4.285s-4.508 1.918-4.508 4.285S16.16 18.9 18.65 18.9Zm14.228 0c2.49 0 4.508-1.92 4.508-4.286 0-2.367-2.019-4.285-4.508-4.285-2.49 0-4.508 1.918-4.508 4.285s2.018 4.286 4.508 4.286Zm14.224 0c2.49 0 4.508-1.92 4.508-4.286 0-2.367-2.018-4.285-4.508-4.285s-4.508 1.918-4.508 4.285 2.018 4.286 4.508 4.286Z"
      fill="currentColor"
    />
  </svg>
);

export default ComputerWindowIcon;
